function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("g", {
  transform: "translate(0 1)",
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("path", {
  fill: "#EEF4FF",
  d: "M0 21.875h131.25v123.958H0z"
}), React.createElement("path", {
  d: "M97.708 48.125c0-18.033 13.68-30.625 30.78-30.625 12.437 0 21.61 6.374 27.206 16.323l-12.437 6.996c-3.73-6.374-8.86-9.483-14.768-9.483-9.172 0-16.012 7.15-16.012 16.789 0 9.638 6.84 16.79 16.012 16.79 5.907 0 11.193-3.11 14.924-9.484l12.28 7.151c-5.596 9.95-15.545 16.168-27.204 16.168-16.79 0-30.78-12.592-30.78-30.625z",
  stroke: "#621FFF",
  strokeWidth: 1.7
}), React.createElement("circle", {
  stroke: "#621FFF",
  strokeWidth: 1.7,
  cx: 127.604,
  cy: 47.396,
  r: 47.396
}));

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    width: 176,
    height: 147,
    viewBox: "0 0 176 147"
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/logotype_icon.b03024e8.svg";
export { SvgComponent as ReactComponent };


//////////////////
// WEBPACK FOOTER
// ./node_modules/svgr/webpack.js!./src/containers/defineNeed/logotype_icon.svg
// module id = 453
// module chunks = 0